<template>
  <!-- S : info text box -->
  <div>

    <!-- S : info text box -->
    <div class="text_box type_blue" v-if="isVcall">
      <div class="text_box_inner">
        <div class="text_box_tit">채팅 상담 후 배달 수령 선택하신 경우</div>
        <p><span><em>카카오톡 알림톡을 통해 채팅 상담 URL이 발송될 예정입니다.<br>결제와 제품 수령을 위해 채팅 상담을 진행해 주세요.</em></span></p>
      </div>				
	  </div>				
    <div class="text_box type_red" v-if="isAbc">
      <div class="text_box_inner">
				<p><span><em>결제와 제품 수령을 위해<br class="mo"> {{ centerLocation }} ABC 마이팩 랩을 방문해 주세요.</em></span></p>
        <ul>
          <li>*  마이팩 랩에서 담당 직원 상담 완료 후 신청하신 마이팩을 구매하실 수 있습니다.</li>
          <li>*  마이팩 랩에서 회원번호화 성함을 말씀하시면 확인을 받으실 수 있습니다.</li>
        </ul>
      </div>
    </div>
    <div class="right_btn">
      <button
        type="button"
        data-layer="abc-info-layer"
        @click="onClickAbcInfo"
      >
        ABC 안내
      </button>

    </div>
  </div>
  <!-- E : info text box -->
</template>

<script>
import { openNewWindow } from '@/utils/common';

export default {
  name: 'InfoBox',
  props: {
    centerLocation: {
      type: String,
      default: '',
    },
    cfmKind: {
      type: String,
      default: 'ABC',
    },
  },
  computed: {
    isVcall() {
      return this.cfmKind === 'VCALL'
    },
    isAbc() {
      return this.cfmKind === 'ABC'
    },
  },
  methods: {
    onClickAbcInfo() {
      openNewWindow(`https://${process.env.SSO_HOST}/store-finder`, 'store-finder');
    },
  },
};
</script>

<style>

</style>
